import { ClassCodeComboBoxComponent } from '../class-code-combo-box/class-code-combo-box.component';

/**
 * 部門コードコンボボックスモデル
 *
 * @export ClassCodeComboBoxModel
 * @class ClassCodeComboBoxModel
 */
export class ClassCodeComboBoxModel {

  /**
   * 部門コードリスト
   */
  public classList: any[] = [];
  // 先頭空白表示
  public blank: boolean = <boolean>true;
  // コンボボックスインスタンス
  public component: ClassCodeComboBoxComponent;
  // コードリスト取得完了
  public completeUpdateFlg: boolean = <boolean>false;
  // 初期設定コード値
  public setClassCode: string;
  // 初期データ自動取得フラグ
  public initAutoLoad: boolean = <boolean>true;
  // 初期設定インデックス
  public selectedIndex: number = <number>-1;
  // 受注コード初期化済フラグ
  public isInitOrderCode: boolean = <boolean>false;


  /**
   * 部門コードを更新する
   *
   * @param {*} classList 部門コードのサーバ取得データ
   * @memberof ClassCodeComboBoxModel
   */
  public updateClassList(classList: any[]): void {
    let tempDataList: any[] = [];

    if (classList !== null) {
      tempDataList = classList;
    }

    // 処理件数
    const index: number = <number>0;

    // コード+：+名称追加
    tempDataList.forEach(item => item.ClassCodeName = item.ClassCode + ':' + item.ClassName);

    // 先頭空白追加
    if (this.blank) {
      tempDataList.splice(index, 0, {
        ClassDivNum: '',
        ClassCode: '',
        ClassName: '',
        LargeClassCode: '',
        LargeClassName: '',
        MiddleClassCode: '',
        MiddleClassName: '',
        SmallClassCode: '',
        SmallClassName: '',
        ClassCodeName: '',
      });
    }

    // テンプから表示用に設定する
    this.classList = tempDataList;
    // リスト生成完了フラグセット
    this.completeUpdateFlg = true;

    // 画面側で設定する
    this.component.updateSelectedClassCode();
    this.component.updateSelectedIndex();
  }

}
